import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { toast } from 'react-toastify';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import PickupCreatedIcon from "../../../../images/pickup-created.png";
import OrderPackageIcon from "../../../../images/order-package.png";
import CopyIcon from "../../../../images/copy-icon.png";
import IconDownload from "../../../../images/icon-download.png";
import Complain from "../../../../images/complain.png";

// Helpers
import { CopyToClipboard } from "../../../../utils/Helpers";

//interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  order_id,
  downloadHandler,
  continueAction
}) => {
  const CoppHandler = () => {
    CopyToClipboard(order_id)

    toast.success(
      "Copied",
      {
        position: 'top-right',
        autoClose: 1000,
        closeOnClick: true,
        pauseOnHover: true
      },
    );
  }
  return (
    <CustomBody>
      <div className="pickup-created-body">
        <KickImage className="pickup-icon" src={PickupCreatedIcon} alt="pickup-address" />
        <p className="title">Pick-up Order Created</p>
        <p className="info">Print out the document below and attach it on your package box. Or, write down the order ID below on the visible side of your box.</p>
        <div className="order-card">
          <KickImage className="order-icon" src={OrderPackageIcon} alt="order icon" />
          <div className="order-text">
            <p className="order-title">Shipper Order ID</p>
            <p className="order-id">{order_id} <KickImage onClick={CoppHandler} className="copy-icon" src={CopyIcon} alt="copy" /></p>
          </div>
          <p className="download" onClick={downloadHandler}><KickImage className="icon-download" src={IconDownload} alt="download" />Download</p>
        </div>
        <p className="complain-text"><KickImage src={Complain} alt="..." className="complain-icon" />The courier needs this information to proceed.</p>
        <CustomButton
          text={"Continue to pick-up schedule"}
          disabled={false}
          onClick={() => continueAction()}
        />
      </div>
    </CustomBody>
  )
}
export default Component;